import React, { FC } from 'react';
import { View } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';

import { useAuthDispatch } from '../../../auth/authContext';
import { SIGN_OUT } from '../../../auth/authTypes';
import { signOut } from '../../../auth/authService';

import Logo from '../Logo';
import styles from './styles';

export type LogoAndLogoutProps = {};

export const LogoAndLogout: FC<LogoAndLogoutProps> = () => {
  const dispatch = useAuthDispatch();
  const handleSignOut = async () => {
    try {
      await signOut();
      dispatch({ type: SIGN_OUT });
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <View style={styles.container}>
      <Logo logoOnly />
      <View style={styles.logoutContainer}>
        <MaterialCommunityIcons
          name="logout"
          size={30}
          color="white"
          onPress={handleSignOut}
        />
      </View>
    </View>
  );
};

export default LogoAndLogout;
